import { Component, Input } from '@angular/core';

@Component({
    selector: 'pnx-loading',
    templateUrl: './loading.control.html'
})
export class LoadingControl {
    @Input() showLoading: boolean = false;
    @Input() position: string = '';
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/loading.control.ts